import { forwardRef, useImperativeHandle, useState } from "react";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useQuery } from "react-query";

import { nhaCungCapApi } from "src/1/apis/nha_cung_cap.api";
import { CModal } from "src/1/common/components/others";
import { TRANG_THAI_NCC } from "src/1/common/constants/freezes";
import { TRANG_THAI_NCC_OPTIONS } from "src/1/common/constants/variables";

import { CDate, CInput, CSelect, CTextarea } from "_components/controls";

const DEFAULT_VALUES = {
  code: "",
  name: "",
  tax: "",
  address: "",
  email: "",
  company_address: "",
  phone: "",
  comany_name: "",
  contact: "",
  provide_date: new Date(),
  note: "",
  active: TRANG_THAI_NCC.DANG_CUNG_CAP,
};

export const NCCModal = forwardRef((props, ref) => {
  //#region Data
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const isPreview = !!id;

  const { data, isFetching } = useQuery({
    queryKey: ["chi-tiet-nha-cung-cap", id],
    queryFn: () => nhaCungCapApi.getById(id),
    enabled: !!id,
    select: (response) => response?.data?.data,
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: DEFAULT_VALUES,
  });
  //#endregion

  //#region Event
  const onClose = () => setOpen(false);

  const onSubmit = handleSubmit(async (values) => {});
  //#endregion

  useEffect(() => {
    if (data) {
      reset(data);
    }
  }, [data]);

  useImperativeHandle(ref, () => ({
    open: (selectedId) => {
      setId(selectedId);
      setOpen(true);
    },
  }));

  //#region Render
  return (
    <CModal
      open={open}
      onClose={onClose}
      title="Thông tin nhà cung cấp"
      fetching={isFetching}
      loading={isSubmitting}
      onSubmit={isPreview ? undefined : onSubmit}
    >
      <div className="grid grid-cols-3 gap-3">
        <Controller
          control={control}
          name="code"
          render={({ field }) => <CInput label="Mã NCC" disabled {...field} />}
        />
        <Controller
          control={control}
          name="name"
          render={({ field }) => (
            <CInput
              label="Tên NCC"
              placeholder="Nhập tên NCC"
              disabled={isPreview}
              {...field}
            />
          )}
        />
        <Controller
          control={control}
          name="tax"
          render={({ field }) => (
            <CInput
              label="Mã số thuế"
              placeholder="Nhập mã số thuế"
              disabled={isPreview}
              {...field}
            />
          )}
        />
        <Controller
          control={control}
          name="address"
          render={({ field }) => (
            <CInput
              label="Địa chỉ"
              placeholder="Nhập địa chỉ"
              disabled={isPreview}
              {...field}
            />
          )}
        />
        <Controller
          control={control}
          name="email"
          render={({ field }) => (
            <CInput
              label="Email"
              placeholder="Nhập email"
              disabled={isPreview}
              {...field}
            />
          )}
        />
        <Controller
          control={control}
          name="company_address"
          render={({ field }) => (
            <CInput
              label="Địa chỉ công ty"
              placeholder="Nhập địa chỉ công ty"
              disabled={isPreview}
              {...field}
            />
          )}
        />
        <Controller
          control={control}
          name="phone"
          render={({ field }) => (
            <CInput
              label="Số điện thoại"
              placeholder="Nhập số điện thoại"
              disabled={isPreview}
              {...field}
            />
          )}
        />
        <Controller
          control={control}
          name="company_name"
          render={({ field }) => (
            <CInput
              label="Tên công ty"
              placeholder="Nhập tên công ty"
              disabled={isPreview}
              {...field}
            />
          )}
        />
        <Controller
          control={control}
          name="contact"
          render={({ field }) => (
            <CInput
              label="Người liên hệ"
              placeholder="Nhập người liên hệ"
              disabled={isPreview}
              {...field}
            />
          )}
        />
        <Controller
          control={control}
          name="provide_date"
          render={({ field }) => (
            <CDate label="Ngày cung cấp" disabled={isPreview} {...field} />
          )}
        />
        <Controller
          control={control}
          name="note"
          render={({ field }) => (
            <CTextarea label="Ghi chú" disabled={isPreview} {...field} />
          )}
        />
        <Controller
          control={control}
          name="active"
          render={({ field }) => (
            <CSelect
              label="Trạng thái"
              options={TRANG_THAI_NCC_OPTIONS}
              disabled={isPreview}
              {...field}
            />
          )}
        />
      </div>
    </CModal>
  );
  //#endregion
});
